/**
 * Compact file size ("512 B", "3.4 KB", "12.0 MB") using 1024 steps.
 * Byte sizes aren't a metric/imperial measurement, so they don't go through
 * the units system (same as the file manager's sizes).
 */
export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
